import _objectWithoutProperties from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/DETOX-SHOP218-JOB1/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["title", "titleId"];

function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };

  return _extends.apply(this, arguments);
}

import * as React from "react";

function FlightRight(_ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M10.24 21.5h.844l4.26-7.58a1 1 0 01.871-.51h3.515c1.055 0 1.255-.758 1.293-1.085l-.006-.248c-.032-.23-.232-.988-1.287-.988h-3.515a1 1 0 01-.871-.51l-4.26-7.58h-.845L12.5 9.785a1 1 0 01-.948 1.317H5.717c-.265 0-.52-.106-.707-.293l-1.478-1.48h-.244l.64 2.5c.025.103.099.454 0 .843l-.64 2.5h.244l1.478-1.48c.188-.186.442-.292.707-.292h5.835a1.003 1.003 0 01.949 1.317L10.24 21.5zm1.428 2H8.852a1 1 0 01-.949-1.316l2.262-6.785H6.13l-1.479 1.479a1.002 1.002 0 01-.707.293H2.002a1 1 0 01-.97-1.248l.94-3.673-.94-3.673A1 1 0 012 7.329h1.946c.264 0 .52.106.706.293L6.13 9.1h4.035L7.904 2.316A1 1 0 018.851 1h2.816c.362 0 .696.195.872.51l4.26 7.579h2.93c2.23 0 3.186 1.737 3.285 2.904l.002.43c-.101 1.25-1.056 2.988-3.287 2.988H16.8l-4.26 7.579a.998.998 0 01-.871.51z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

var MemoFlightRight = React.memo(FlightRight);
export default MemoFlightRight;